const ITEMS = [
  "MEU EX DE VOLTA",
  "50 SIMPATIAS",
  "RITUAIS DE AMOR",
  "ORAÇÕES & REFLEXÕES",
  "RENOVAÇÃO",
  "NOVOS COMEÇOS",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="relative overflow-hidden border-y border-dourado/15 bg-obsidian py-5"
    >
      <div className="anim-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="px-8 font-cinzel text-sm tracking-[0.35em] text-dourado/70">
                  {item}
                </span>
                <svg viewBox="0 0 12 12" className="h-2.5 w-2.5 fill-rosa/70">
                  <path d="M6 0l1.5 4.5L12 6 7.5 7.5 6 12 4.5 7.5 0 6l4.5-1.5z" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
